import { ChangeEvent } from 'react';

import { CustomInput, Text } from '../../../shared/uiComponents';
import { useSignatureDate, useSoapNoteFieldDisabled } from '../helpers';
import { Behaviors, SignatureInput, Targets, TimeInfo } from '../components';
import { ACTIONS, ActionProperties, DiscretionarySessionState } from './discretionarySessionReducer';

import { useSelector } from '../../../redux/store';

const DiscretionarySessionData = ({
	data,
	setData,
	save,
}: {
	data: DiscretionarySessionState;
	save: () => void;
	setData: (action: ActionProperties) => void;
}) => {
	const signatureDate = useSignatureDate();
	const sessionTargets = useSelector((state) => state.session.sessionTargets);
	const sessionBehaviors = useSelector((state) => state.dataCollection.sessionBehaviors);
	const { getFieldDisabled } = useSoapNoteFieldDisabled();

	const sessionSummaryHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setData({ payload: value, type: ACTIONS.setSessionSummary });
	};

	const signatureHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setData({ payload: value.toUpperCase(), type: ACTIONS.setSignature });
	};

	return (
		<>
			<TimeInfo disabled={getFieldDisabled('startTime')} save={save} />
			<CustomInput
				label="Session Summary:"
				value={data.sessionSummary}
				onChange={sessionSummaryHandler}
				className="marginBottom16"
				multiline
				disabled={getFieldDisabled('sessionSummary')}
				onBlur={save}
			/>
			{(Boolean(sessionTargets.length) || Boolean(sessionBehaviors.length)) && (
				<Text title="Session Details" type="h4" font="header" fontWeight="semiBold" className="marginBottom16 title" />
			)}
			<Targets />
			<Behaviors />
			<SignatureInput
				value={data.signature}
				setValue={signatureHandler}
				disabled={getFieldDisabled('signature')}
				onBlur={save}
				error={false}
			/>
			<Text title={`Date/time of signature: ${signatureDate}`} fontWeight="semiBold" />
		</>
	);
};

export default DiscretionarySessionData;
